// extracted by mini-css-extract-plugin
module.exports = {"blippLogotype":"FooterBlippInfo_blippLogotype__oljQ7","address":"FooterBlippInfo_address__8LGz9"};